(function () {
  'use strict';

  const STORAGE_KEY = 'bespoke-table-draft';
  const ANCHOR_OFFSET = 80;

  let currentStep = 1;
  let totalSteps = 5;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    setupSmoothScroll();
    setupAnchorNav();
    setupStickyCta();
    setupChips();
    setupStones();
    setupInspirationFilters();
    setupInspirationShowMore();
    setupInspirationModal();
    setupMultiStep();
    setupTableTypePresets();
    setupBaseTypeUI();
    setupFormPersistence();
    setupFormSubmission();
  }

  /* =============== Smooth scroll =============== */
  function setupSmoothScroll() {
    document.querySelectorAll('[data-bespoke-scroll]').forEach((link) => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        if (!href || !href.startsWith('#')) return;
        const target = document.querySelector(href);
        if (!target) return;
        e.preventDefault();
        const top = target.getBoundingClientRect().top + window.pageYOffset - ANCHOR_OFFSET;
        window.scrollTo({ top, behavior: 'smooth' });

        const prefill = link.dataset.bespokePrefill;
        if (prefill) {
          try { applyPrefill(JSON.parse(prefill)); } catch {}
        }
      });
    });
  }

  /* =============== Side nav =============== */
  function setupAnchorNav() {
    const nav = document.querySelector('[data-bespoke-side-nav], [data-bespoke-anchor-nav]');
    if (!nav) return;
    const hero = document.querySelector('.bespoke-hero');
    const sections = Array.from(document.querySelectorAll('[data-anchor]'));
    const links = Array.from(nav.querySelectorAll('a'));

    if (hero) {
      new IntersectionObserver(
        ([entry]) => nav.classList.toggle('is-visible', !entry.isIntersecting),
        { threshold: 0.05 }
      ).observe(hero);
    }

    if (sections.length) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const id = entry.target.id;
              links.forEach((l) => l.classList.toggle('is-active', l.getAttribute('href') === '#' + id));
            }
          });
        },
        { rootMargin: '-40% 0px -50% 0px', threshold: 0 }
      );
      sections.forEach((s) => observer.observe(s));
    }
  }

  /* =============== Sticky CTA =============== */
  function setupStickyCta() {
    const cta = document.querySelector('[data-bespoke-sticky-cta]');
    const hero = document.querySelector('.bespoke-hero');
    const form = document.getElementById('bespoke-form');
    if (!cta || !hero || !form) return;

    cta.hidden = false;
    let heroPassed = false;
    let formVisible = false;
    const update = () => cta.classList.toggle('is-visible', heroPassed && !formVisible);

    new IntersectionObserver(([e]) => { heroPassed = !e.isIntersecting; update(); }, { threshold: 0 }).observe(hero);
    new IntersectionObserver(([e]) => { formVisible = e.isIntersecting; update(); }, { threshold: 0.15 }).observe(form);
  }

  /* =============== Chips =============== */
  function setupChips() {
    document.querySelectorAll('[data-bespoke-chips]').forEach((group) => {
      const key = group.dataset.bespokeChips;
      const hidden = document.querySelector(`[data-field="${key}"]`);
      group.querySelectorAll('.bespoke-chip').forEach((chip) => {
        chip.addEventListener('click', () => {
          const isSel = chip.classList.contains('is-selected');
          group.querySelectorAll('.bespoke-chip').forEach((c) => c.classList.remove('is-selected'));
          if (!isSel) {
            chip.classList.add('is-selected');
            if (hidden) hidden.value = chip.dataset.value;
          } else if (hidden) hidden.value = '';
          saveDraft();
        });
      });
    });
  }

  /* =============== Stones =============== */
  function setupStones() {
    const grid = document.querySelector('[data-bespoke-stones]');
    if (!grid) return;
    const hidden = document.querySelector('[data-field="stone"]');
    grid.querySelectorAll('.bespoke-stone').forEach((stone) => {
      stone.addEventListener('click', () => {
        const isPressed = stone.getAttribute('aria-pressed') === 'true';
        grid.querySelectorAll('.bespoke-stone').forEach((s) => s.setAttribute('aria-pressed', 'false'));
        if (!isPressed) {
          stone.setAttribute('aria-pressed', 'true');
          if (hidden) hidden.value = stone.dataset.value;
        } else if (hidden) hidden.value = '';
        saveDraft();
      });
    });
  }

  /* =============== Inspiration filters =============== */
  function setupInspirationFilters() {
    const filters = document.querySelector('[data-bespoke-filters]');
    const grid = document.querySelector('[data-bespoke-insp-grid]');
    if (!filters || !grid) return;

    filters.querySelectorAll('.bespoke-insp-filter').forEach((btn) => {
      btn.addEventListener('click', () => {
        filters.querySelectorAll('.bespoke-insp-filter').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const filter = btn.dataset.filter;
        grid.querySelectorAll('.bespoke-insp-card').forEach((card) => {
          if (card.hasAttribute('data-insp-extra')) return;
          card.hidden = filter !== 'all' && card.dataset.useCase !== filter;
        });
      });
    });
  }

  /* =============== Inspiration show more =============== */
  function setupInspirationShowMore() {
    const grid = document.querySelector('[data-bespoke-insp-grid]');
    if (!grid) return;
    grid.querySelectorAll('[data-insp-extra]').forEach((c) => { c.hidden = true; });

    const btn = document.querySelector('[data-bespoke-show-more]');
    if (!btn) return;
    const wrap = btn.closest('[data-bespoke-insp-more]');

    btn.addEventListener('click', () => {
      grid.querySelectorAll('[data-insp-extra]').forEach((c) => {
        c.removeAttribute('data-insp-extra');
        c.hidden = false;
      });
      if (wrap) wrap.hidden = true;
      const activeFilter = document.querySelector('.bespoke-insp-filter.is-active');
      if (activeFilter) {
        const filter = activeFilter.dataset.filter;
        grid.querySelectorAll('.bespoke-insp-card').forEach((card) => {
          card.hidden = filter !== 'all' && card.dataset.useCase !== filter;
        });
      }
    });
  }

  /* =============== Inspiration modal =============== */
  function setupInspirationModal() {
    const modal = document.querySelector('[data-bespoke-insp-modal]');
    if (!modal) return;
    const body = modal.querySelector('[data-bespoke-modal-body]');
    const panel = modal.querySelector('.bespoke-modal__panel');
    let lastFocused = null;

    document.querySelectorAll('[data-bespoke-insp-open]').forEach((opener) => {
      opener.addEventListener('click', () => {
        const card = opener.closest('.bespoke-insp-card');
        const tpl = card && card.querySelector('[data-bespoke-insp-detail]');
        if (!tpl) return;
        lastFocused = opener;
        body.innerHTML = '';
        body.appendChild(tpl.content.cloneNode(true));

        body.querySelectorAll('[data-bespoke-thumb]').forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const src = thumb.dataset.bespokeThumb;
            const mainImg = body.querySelector('[data-bespoke-insp-main] img');
            if (mainImg && src) {
              mainImg.style.opacity = '0';
              setTimeout(() => {
                mainImg.src = src;
                mainImg.style.opacity = '';
              }, 220);
            }
            body.querySelectorAll('[data-bespoke-thumb]').forEach((t) => t.classList.remove('is-active'));
            thumb.classList.add('is-active');
          });
        });

        body.querySelectorAll('[data-bespoke-scroll]').forEach((link) => {
          link.addEventListener('click', (e) => {
            const href = link.getAttribute('href');
            if (!href || !href.startsWith('#')) return;
            e.preventDefault();
            const prefill = link.dataset.bespokePrefill;
            if (prefill) { try { applyPrefill(JSON.parse(prefill)); } catch {} }
            closeModal(modal);
            setTimeout(() => {
              const target = document.querySelector(href);
              if (target) {
                const top = target.getBoundingClientRect().top + window.pageYOffset - ANCHOR_OFFSET;
                window.scrollTo({ top, behavior: 'smooth' });
              }
            }, 320);
          });
        });

        openModal(modal, panel);
      });
    });

    modal.querySelectorAll('[data-bespoke-modal-close]').forEach((el) => {
      el.addEventListener('click', () => closeModal(modal, lastFocused));
    });
    modal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal(modal, lastFocused);
    });
  }

  function openModal(modal, panel) {
    modal.hidden = false;
    modal.removeAttribute('aria-hidden');
    requestAnimationFrame(() => modal.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
    setTimeout(() => panel && panel.focus(), 80);
  }
  function closeModal(modal, refocus) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(() => {
      modal.hidden = true;
      if (refocus && typeof refocus.focus === 'function') refocus.focus();
    }, 300);
  }

  /* =============== Multi-step form =============== */
  function setupMultiStep() {
    const card = document.querySelector('[data-bespoke-form-card]');
    if (!card) return;
    const steps = Array.from(card.querySelectorAll('.bespoke-form-step'));
    totalSteps = steps.length;
    const nextBtn = card.querySelector('[data-bespoke-next]');
    const backBtn = card.querySelector('[data-bespoke-back]');
    const submitBtn = card.querySelector('[data-bespoke-submit]');
    const stepNum = card.querySelector('[data-bespoke-step-num]');
    const stepName = card.querySelector('[data-bespoke-step-name]');
    const progress = card.querySelectorAll('[data-bespoke-progress] [data-step]');

    function showStep(n, direction) {
      n = Math.max(1, Math.min(totalSteps, n));
      currentStep = n;

      steps.forEach((s) => {
        const isActive = parseInt(s.dataset.bespokeStep, 10) === n;
        s.classList.remove('is-active', 'is-back');
        if (isActive) {
          s.classList.add('is-active');
          if (direction === 'back') s.classList.add('is-back');
        }
      });

      progress.forEach((bar) => {
        const i = parseInt(bar.dataset.step, 10);
        bar.classList.remove('is-active', 'is-done');
        if (i === n) bar.classList.add('is-active');
        else if (i < n) bar.classList.add('is-done');
      });

      if (stepNum) stepNum.textContent = `Step ${n} of ${totalSteps}`;
      const activeStep = steps.find((s) => parseInt(s.dataset.bespokeStep, 10) === n);
      if (stepName && activeStep) stepName.textContent = activeStep.dataset.name || '';

      backBtn.hidden = n === 1;
      nextBtn.hidden = n === totalSteps;
      submitBtn.hidden = n !== totalSteps;
    }

    function validateStep(n) {
      const activeStep = steps.find((s) => parseInt(s.dataset.bespokeStep, 10) === n);
      if (!activeStep) return true;
      const required = activeStep.querySelectorAll('[required]');
      let firstInvalid = null;
      required.forEach((el) => {
        const valid = el.checkValidity();
        el.classList.toggle('is-invalid', !valid);
        if (!valid && !firstInvalid) firstInvalid = el;
      });
      if (firstInvalid) firstInvalid.focus();
      return !firstInvalid;
    }

    function validateAll() {
      let firstInvalid = null;
      let firstInvalidStepNum = null;
      steps.forEach((step) => {
        step.querySelectorAll('[required]').forEach((el) => {
          const valid = el.checkValidity();
          el.classList.toggle('is-invalid', !valid);
          if (!valid && !firstInvalid) {
            firstInvalid = el;
            firstInvalidStepNum = parseInt(step.dataset.bespokeStep, 10);
          }
        });
      });
      if (firstInvalid) {
        if (firstInvalidStepNum) showStep(firstInvalidStepNum);
        setTimeout(() => firstInvalid.focus(), 100);
      }
      return !firstInvalid;
    }

    nextBtn.addEventListener('click', () => {
      if (!validateStep(currentStep)) return;
      showStep(currentStep + 1, 'forward');
      scrollCardIntoView(card);
    });
    backBtn.addEventListener('click', () => {
      showStep(currentStep - 1, 'back');
      scrollCardIntoView(card);
    });

    // Allow clicking progress bars to jump to completed steps
    progress.forEach((bar) => {
      bar.style.cursor = 'pointer';
      bar.addEventListener('click', () => {
        const target = parseInt(bar.dataset.step, 10);
        if (target <= currentStep) showStep(target, target < currentStep ? 'back' : 'forward');
      });
    });

    showStep(1);
  }

  function scrollCardIntoView(card) {
    const rect = card.getBoundingClientRect();
    if (rect.top < 100 || rect.top > 200) {
      const top = rect.top + window.pageYOffset - 100;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }

  /* =============== Form persistence =============== */
  function setupFormPersistence() {
    const form = document.querySelector('[data-bespoke-form]');
    if (!form) return;
    loadDraft();
    form.addEventListener('input', debounce(saveDraft, 600));
    form.addEventListener('change', saveDraft);
  }

  function saveDraft() {
    const form = document.querySelector('[data-bespoke-form]');
    if (!form) return;
    const data = {};
    form.querySelectorAll('input, select, textarea').forEach((el) => {
      if (el.type === 'checkbox') data[el.name] = el.checked;
      else if (el.type !== 'submit' && el.name) data[el.name] = el.value;
    });
    form.querySelectorAll('[data-bespoke-chips]').forEach((group) => {
      const sel = group.querySelector('.bespoke-chip.is-selected');
      data['__chip_' + group.dataset.bespokeChips] = sel ? sel.dataset.value : '';
    });
    const stone = form.querySelector('.bespoke-stone[aria-pressed="true"]');
    data['__stone'] = stone ? stone.dataset.value : '';

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      showDraftNote();
    } catch {}
  }

  function loadDraft() {
    let data;
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      data = JSON.parse(raw);
    } catch { return; }
    if (!data) return;

    const form = document.querySelector('[data-bespoke-form]');
    if (!form) return;

    Object.keys(data).forEach((key) => {
      if (key.startsWith('__')) return;
      const el = form.querySelector(`[name="${CSS.escape(key)}"]`);
      if (!el) return;
      if (el.type === 'checkbox') el.checked = !!data[key];
      else el.value = data[key] || '';
    });

    form.querySelectorAll('[data-bespoke-chips]').forEach((group) => {
      const val = data['__chip_' + group.dataset.bespokeChips];
      if (!val) return;
      group.querySelectorAll('.bespoke-chip').forEach((c) => {
        if (c.dataset.value === val) c.classList.add('is-selected');
      });
      const hidden = document.querySelector(`[data-field="${group.dataset.bespokeChips}"]`);
      if (hidden) hidden.value = val;
    });
    if (data['__stone']) {
      form.querySelectorAll('.bespoke-stone').forEach((s) => {
        if (s.dataset.value === data['__stone']) s.setAttribute('aria-pressed', 'true');
      });
      const hidden = document.querySelector('[data-field="stone"]');
      if (hidden) hidden.value = data['__stone'];
    }
  }

  function clearDraft() { try { localStorage.removeItem(STORAGE_KEY); } catch {} }

  let draftTimer = null;
  function showDraftNote() {
    const note = document.querySelector('[data-bespoke-draft-note]');
    if (!note) return;
    note.hidden = false;
    note.classList.add('is-visible');
    clearTimeout(draftTimer);
    draftTimer = setTimeout(() => note.classList.remove('is-visible'), 1800);
  }

  /* =============== Submission =============== */
  function setupFormSubmission() {
    const form = document.querySelector('[data-bespoke-form]');
    if (!form) return;
    const modal = document.querySelector('[data-bespoke-success-modal]');
    const submitBtn = form.querySelector('[data-bespoke-submit]');
    const submitLabel = form.querySelector('[data-bespoke-submit-label]');
    const spinner = form.querySelector('.bespoke-spinner');

    if (document.querySelector('[data-bespoke-server-success]')) {
      openSuccessModal();
      clearDraft();
      history.replaceState({}, '', window.location.pathname + '#bespoke-form');
    }

    form.addEventListener('submit', async (e) => {
      const honey = form.querySelector('[name="contact[website]"]');
      if (honey && honey.value) { e.preventDefault(); return; }
      if (!validateAll()) { e.preventDefault(); return; }

      if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
      if (spinner) spinner.hidden = false;
      if (submitLabel) submitLabel.textContent = 'Sending…';

      if (typeof window.fetch !== 'function') return;

      e.preventDefault();
      try {
        const fd = new FormData(form);
        const res = await fetch(form.action, {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json, text/html' }
        });
        if (res.ok || res.status === 200 || res.status === 302) {
          openSuccessModal();
          clearDraft();
          form.reset();
          form.querySelectorAll('.bespoke-chip.is-selected').forEach((c) => c.classList.remove('is-selected'));
          form.querySelectorAll('.bespoke-stone[aria-pressed="true"]').forEach((s) => s.setAttribute('aria-pressed', 'false'));
        } else {
          throw new Error('Submission failed: ' + res.status);
        }
      } catch (err) {
        form.submit();
        return;
      } finally {
        if (submitBtn) submitBtn.removeAttribute('aria-disabled');
        if (spinner) spinner.hidden = true;
        if (submitLabel) submitLabel.textContent = 'Send Request';
      }
    });

    if (modal) {
      modal.querySelectorAll('[data-bespoke-success-close]').forEach((el) => {
        el.addEventListener('click', () => closeModal(modal));
      });
      modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeModal(modal);
      });
    }
  }

  function openSuccessModal() {
    const modal = document.querySelector('[data-bespoke-success-modal]');
    if (!modal) return;
    const panel = modal.querySelector('.bespoke-modal__panel');
    openModal(modal, panel);
  }

  /* =============== Prefill =============== */
  function applyPrefill(data) {
    if (!data) return;
    if (data.style) {
      const group = document.querySelector('[data-bespoke-chips="style"]');
      if (group) {
        group.querySelectorAll('.bespoke-chip').forEach((c) => {
          if (c.dataset.value.toLowerCase().includes(String(data.style).toLowerCase().split(' ')[0])) {
            c.classList.add('is-selected');
            const hidden = document.querySelector('[data-field="style"]');
            if (hidden) hidden.value = c.dataset.value;
          }
        });
      }
    }
    if (data.stone) {
      const match = Array.from(document.querySelectorAll('.bespoke-stone')).find(
        (s) => s.dataset.value && s.dataset.value.toLowerCase() === String(data.stone).toLowerCase()
      );
      if (match) {
        document.querySelectorAll('.bespoke-stone').forEach((s) => s.setAttribute('aria-pressed', 'false'));
        match.setAttribute('aria-pressed', 'true');
        const hidden = document.querySelector('[data-field="stone"]');
        if (hidden) hidden.value = match.dataset.value;
      }
    }
    saveDraft();
  }

  /* =============== Base type UI =============== */
  function setupBaseTypeUI() {
    const baseGroup = document.querySelector('[data-bespoke-base-type]');
    const steelRow = document.querySelector('[data-bespoke-steel-colours]');
    if (!baseGroup || !steelRow) return;

    baseGroup.addEventListener('click', (e) => {
      const chip = e.target.closest('.bespoke-chip');
      if (!chip) return;
      const isSteel = chip.dataset.value === 'Steel base';
      steelRow.hidden = !isSteel;
      if (!isSteel) {
        steelRow.querySelectorAll('.bespoke-chip.is-selected').forEach(c => c.classList.remove('is-selected'));
        const hidden = document.querySelector('[data-field="steel_colour"]');
        if (hidden) hidden.value = '';
      }
    });
  }

  /* =============== Table type presets =============== */
  function setupTableTypePresets() {
    const typeSelect = document.querySelector('[name="contact[table_type]"]');
    const shapeSelect = document.querySelector('[name="contact[shape]"]');
    const dimsInput = document.querySelector('[name="contact[dimensions]"]');
    if (!typeSelect || !shapeSelect || !dimsInput) return;

    const RESTRICTED_SHAPES = {
      'Console':        ['Round', 'Square', 'Organic / custom'],
      'Column / Pillar':['Rectangular', 'Oval', 'Organic / custom'],
    };

    const DEFAULT_SHAPES = {
      'Dining':         'Round',
      'Console':        'Rectangular',
      'Column / Pillar':'Square',
    };

    const PRESETS = {
      'Console':        { 'Rectangular': '100 × 25 × 77 cm', 'Oval': '100 × 25 × 77 cm', '*': '100 × 25 × 77 cm' },
      'Dining':         { 'Rectangular': '160 × 90 × 74 cm', 'Square': '120 × 120 × 74 cm', 'Oval': '160 × 90 × 74 cm', 'Round': 'Ø 120 × 74 cm', 'Organic / custom': '160 × 90 × 74 cm', 'Open to suggestions': '160 × 90 × 74 cm' },
      'Coffee':         { 'Rectangular': '100 × 60 × 38 cm', 'Square': '60 × 60 × 38 cm', 'Oval': '100 × 60 × 38 cm', 'Round': 'Ø 60 × 38 cm', 'Organic / custom': '100 × 60 × 38 cm', 'Open to suggestions': '100 × 60 × 38 cm', '*': '100 × 60 × 38 cm' },
      'Side':           { 'Square': '35 × 35 × 38 cm', 'Round': 'Ø 35 × 38 cm', '*': '35 × 35 × 38 cm' },
      'Column / Pillar':{ 'Square': '25 × 25 × 70 cm', 'Round': 'Ø 25 × 70 cm' },
    };

    function updateShapes() {
      const type = typeSelect.value;
      const restricted = RESTRICTED_SHAPES[type] || [];
      let selectedDisabled = false;
      Array.from(shapeSelect.options).forEach((opt) => {
        if (!opt.value) return;
        const block = restricted.includes(opt.value);
        opt.disabled = block;
        opt.style.display = block ? 'none' : '';
        if (block && opt.selected) selectedDisabled = true;
      });
      if (selectedDisabled || DEFAULT_SHAPES[type]) {
        const def = DEFAULT_SHAPES[type];
        if (def) shapeSelect.value = def;
        else shapeSelect.value = '';
      }
    }

    function updateDimensions() {
      const type = typeSelect.value;
      const shape = shapeSelect.value;
      if (!type) return;
      const typePresets = PRESETS[type];
      if (!typePresets) return;
      const preset = typePresets[shape] || typePresets['*'];
      if (preset) dimsInput.value = preset;
    }

    typeSelect.addEventListener('change', () => {
      updateShapes();
      updateDimensions();
      saveDraft();
    });
    shapeSelect.addEventListener('change', () => {
      updateDimensions();
      saveDraft();
    });

    // Apply presets for the pre-selected type on load
    updateShapes();
    updateDimensions();
  }

  /* =============== Utils =============== */
  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), wait);
    };
  }
})();
